import { useI18n } from "@/i18n/translations";
import { disciplines } from "@/data/disciplines";
import { ambitiIntro } from "@/data/content";
import { Seo } from "@/components/Seo";
import { DemoBadge, FotoSlot, PageHeader, SlotText } from "@/components/Editorial";
import { Reveal } from "@/components/Reveal";

export const Ambiti = () => {
  const { t, lang } = useI18n();
  return (
    <>
      <Seo titleKey="seo.ambiti.title" descKey="seo.ambiti.desc" path="/ambiti-di-ricerca" />
      <PageHeader
        kickerKey="amb.kicker"
        titleKey="amb.title"
        aside={
          <FotoSlot
            src="https://thumb.wikimedia.org/wikipedia/commons/thumb/7/7c/Genova_Universit%C3%A0_di_Genova_Cortile_9.jpg/960px-Genova_Universit%C3%A0_di_Genova_Cortile_9.jpg"
            captionKey="foto.ambiti"
            testid="foto-ambiti"
            ratio="aspect-[21/9] sm:aspect-auto sm:min-h-[140px]"
            fill
          />
        }
      >
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-mutedtx">
          <SlotText slot={ambitiIntro} />
        </p>
        <DemoBadge className="mt-4" />
      </PageHeader>

      <section className="container-x py-16 sm:py-20">
        <div className="border-t border-borderc" data-testid="disciplines-list-container">
          {disciplines.map((d, i) => (
            <Reveal key={d.n} delay={Math.min(i * 0.03, 0.25)} y={16}>
              <article className="group grid grid-cols-[auto_1fr] items-baseline gap-5 border-b border-borderc px-1 py-6 transition-colors hover:bg-cardwhite md:grid-cols-[80px_1fr_auto]">
                <span className="font-serif text-lg italic text-bordeaux" aria-hidden="true">
                  {String(d.n).padStart(2, "0")}
                </span>
                <h2 className="font-serif text-xl font-medium text-ink transition-transform duration-300 group-hover:translate-x-1.5 sm:text-2xl" data-testid={`discipline-item-${d.n}`}>
                  {lang === "en" && d.en ? d.en : d.it}
                </h2>
                {(lang === "en" ? d.it : d.en) && (
                  <span className="hidden text-sm italic text-mutedtx md:block">{lang === "en" ? d.it : d.en}</span>
                )}
              </article>
            </Reveal>
          ))}
        </div>
        <Reveal className="mt-8">
          <p className="max-w-2xl text-xs italic leading-relaxed text-mutedtx">{t("amb.gloss_note")}</p>
        </Reveal>
      </section>
    </>
  );
};

export default Ambiti;
